import * as React from 'react';

import { Fecha } from 'src/componentes';
import { DatosMatricula } from '../tipos';
import Asignatura from './Asignatura';
import Campo from './Campo';
import Info from './Info';

const InformacionMatricula: React.FunctionComponent<DatosMatricula> = props => {
    const {
        numeroDeMatricula,
        asignaturas,
        electivo,
        area,
        plan,
        fechaDeContrato,
        observacion,
    } = props;
    return (
        <Info titulo='Información de matrícula'>
            <Campo etiqueta='Número de matricula' valor={numeroDeMatricula} />
            <Campo etiqueta='Área' valor={area} />
            <Campo etiqueta='Plan' valor={plan} />
            <Asignatura asignaturas={asignaturas} />
            {electivo ? <Campo etiqueta='Electivo' valor={'⁕ ' + electivo} /> : false}
            <Campo etiqueta='Fecha de contrato' valor={<Fecha fecha={fechaDeContrato} />} />
            <div style={{ fontWeight: 'bold', marginTop: '1em' }} />
            <Campo etiqueta='Observaciones' valor='' />
            <span
                style={{
                    display: 'inline-block',
                    maxWidth: '23em',
                    fontWeight: 'bold',
                }}
            >
                {observacion}
            </span>
        </Info>
    );
};

export default InformacionMatricula;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/InformacionMatricula.tsx